/* eslint-disable no-continue */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import React, {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import axios, { Method } from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Typography,
  Box,
  TextField,
  Button,
  Paper,
  CircularProgress,
} from '@mui/material';
import {
  findAnnotaionsFromId,
  getHeightMegduSlov,
  selectTheme,
} from '../../utils/utils';
import { AnnotaionDto } from '../../dto/LectionImageDto';
import { LECTION_ROUTE } from '../../constant/routes';
import { DialogAnnotation } from './DialogAnnotation';
import { PlayerKinescopeDto } from '../../dto/PlayerKinescopeDto';

interface Props {
  dto: PlayerKinescopeDto[];
  open: boolean;
  fontSize: string;
  curTheme: number;
  onClose: (e: any) => void;
}

interface Message {
  role: 'user' | 'assistant';
  content: string;
  isStreaming?: boolean;
}

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>
  ) => <Slide direction="up" ref={ref} {...props} />
);

export const DialogChatAi: FunctionComponent<Props> = ({
  dto,
  open,
  fontSize,
  curTheme,
  onClose,
}) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Получаем текст конспекта из dto
  const lectureText = useMemo(() => {
    if (!dto || dto.length === 0) return '';
    // Собираем весь текст из всех PlayerKinescopeDto
    return dto.map((item) => item.text || '').join('\n\n');
  }, [dto]);

  // Автоскролл при новых сообщениях
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Фокус на поле ввода при открытии диалога
  useEffect(() => {
    if (open && textareaRef.current) {
      setTimeout(() => {
        textareaRef.current?.focus();
      }, 300);
    }
  }, [open]);

  const formatMessage = (text: string) => {
    if (!text) return '';

    // Экранирование HTML (безопасность)
    const escapeHtml = (str: string) =>
      str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    let formatted = escapeHtml(text);

    // Порядок важен! Сначала сложные паттерны
    formatted = formatted
      // Заголовки (#, ##, ###)
      .replace(
        /^### (.*?)$/gm,
        '<h3 style="font-size:1.2rem; font-weight:bold; margin:0.5rem 0">$1</h3>'
      )
      .replace(
        /^## (.*?)$/gm,
        '<h2 style="font-size:1.4rem; font-weight:bold; margin:0.5rem 0">$1</h2>'
      )
      .replace(
        /^# (.*?)$/gm,
        '<h1 style="font-size:1.6rem; font-weight:bold; margin:0.5rem 0">$1</h1>'
      )

      // Комбинированные стили (***жирный курсив***)
      .replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>')

      // Жирный (**текст**)
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')

      // Курсив (*текст* или _текст_)
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/_(.*?)_/g, '<em>$1</em>')

      // Зачёркивание (~~текст~~)
      .replace(/~~(.*?)~~/g, '<del>$1</del>')

      // Код inline (`код`)
      .replace(
        /`(.*?)`/g,
        '<code style="background:rgba(0,0,0,0.05); padding:0.2rem 0.3rem; border-radius:3px; font-family:monospace">$1</code>'
      )

      // Ссылки [текст](url)
      .replace(
        /\[(.*?)\]\((.*?)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#1976d2; text-decoration:underline">$1</a>'
      )

      // Маркированные списки (* или -)
      .replace(/^[*-] (.*?)$/gm, '<li style="margin:0.2rem 0">$1</li>')

      // Нумерованные списки (1., 2., 3.)
      .replace(/^\d+\. (.*?)$/gm, '<li style="margin:0.2rem 0">$1</li>')

      // Цитаты (> текст)
      .replace(
        /^&gt; (.*?)$/gm,
        '<blockquote style="border-left:3px solid #1976d2; margin:0.5rem 0; padding-left:1rem; opacity:0.8">$1</blockquote>'
      )

      // Горизонтальная линия (--- или ***)
      .replace(
        /^---$/gm,
        '<hr style="margin:1rem 0; border:none; border-top:1px solid #ddd" />'
      )
      .replace(
        /^\*\*\*$/gm,
        '<hr style="margin:1rem 0; border:none; border-top:1px solid #ddd" />'
      );

    // Обёртка списков
    formatted = formatted.replace(
      /(<li.*?>.*?<\/li>\n?)+/g,
      (match) =>
        `<ul style="margin:0.5rem 0; padding-left:1.5rem">${match}</ul>`
    );

    // Перенос строк
    formatted = formatted.replace(/\n/g, '<br />');

    // Чистим лишние теги
    formatted = formatted
      .replace(/<ul><\/ul>/g, '')
      .replace(/<br \/><\/ul>/g, '</ul>')
      .replace(/<br \/><\/li>/g, '</li>');

    return formatted;
  };

  // Функция для построения промпта с контекстом конспекта
  const buildPrompt = (message: string, history: Message[]) => {
    // Берём последние 10 сообщений из истории
    const recentHistory = history.slice(-10);

    let prompt = `Ты — учебный AI-помощник (бета-версия) для студентов медицинского университета.

📚 **ТВОЙ КОНТЕКСТ (ЛЕКЦИЯ/КОНСПЕКТ):**
Это содержание учебного материала, на основе которого ты должен отвечать:

"""
${
  lectureText ||
  'Конспект не загружен. Отвечай на основе общих медицинских знаний.'
}
"""

⚠️ **ВАЖНО:** Воспринимай текст выше как истину. Отвечай строго на основе этого конспекта. Если вопрос не относится к конспекту или информации недостаточно — скажи об этом честно.

📚 Твои задачи:
- Помогать студентам разбираться в медицинских концепциях и терминах ИЗ КОНСПЕКТА
- Делать конспекты лекций на основе ПРЕДОСТАВЛЕННОГО ТЕКСТА
- Переводить медицинскую литературу на русский и английский языки
- Отвечать на учебные вопросы по анатомии, физиологии, биохимии, гистологии и латыни, используя КОНСПЕКТ
- Объяснять сложные темы простым языком, НЕ ВЫХОДЯ за рамки конспекта

⚠️ Важное ограничение:
Ты — учебный инструмент, а не замена клинической практике. Всегда подчёркивай, что для принятия врачебных решений студенты должны обращаться к преподавателям и официальным руководствам.

Правила ответов:
1. Отвечай структурированно, выделяй ключевые термины
2. При конспектировании сохраняй главную мысль, убирай воду
3. Если вопрос выходит за рамки учебной программы — вежливо сообщи об этом
4. Если информации в конспекте недостаточно — скажи об этом и предложи обратиться к дополнительным источникам
5. **КАТЕГОРИЧЕСКИ ЗАПРЕЩЕНО выдумывать информацию, которой нет в конспекте**

История диалога:\n`;

    for (const msg of recentHistory) {
      if (msg.role === 'user') {
        prompt += `Пользователь-студент: ${msg.content}\n`;
      } else if (msg.role === 'assistant') {
        prompt += `Помощник: ${msg.content}\n`;
      }
    }

    prompt += `Пользователь-студент: ${message}\n`;
    prompt += `Помощник: `;

    console.log(prompt);

    return prompt;
  };

  const sendMessage = async () => {
    if (!input.trim() || isLoading) return;

    const userMessage: Message = { role: 'user', content: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput('');
    setIsLoading(true);

    // Добавляем пустое сообщение ассистента
    setMessages((prev) => [
      ...prev,
      { role: 'assistant', content: '', isStreaming: true },
    ]);

    try {
      const startTime = Date.now();

      // ✅ ПОТОКОВЫЙ ЗАПРОС (stream: true)
      const response = await fetch('https://cloud-uchi.ru/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'gemma4:e4b',
          messages: [
            {
              role: 'user',
              content: buildPrompt(input, messages),
            },
          ],
          stream: true, // ← КЛЮЧЕВОЙ МОМЕНТ
          think: false,
          options: {
            temperature: 0.1,
            num_predict: 2000,
            num_ctx: 8192,
          },
        }),
      });

      const reader = response.body?.getReader();
      if (!reader) throw new Error('No reader');

      const decoder = new TextDecoder();
      let accumulatedText = '';
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        // Декодируем чанк
        buffer += decoder.decode(value, { stream: true });

        // Разбиваем на строки (SSE формат)
        const lines = buffer.split('\n');
        buffer = lines.pop() || ''; // Оставляем последний неполный кусок

        for (const line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine) continue;

          // Убираем префикс "data: " если есть
          let jsonStr = trimmedLine;
          if (trimmedLine.startsWith('data: ')) {
            jsonStr = trimmedLine.slice(6);
          }

          if (jsonStr === '[DONE]') continue;

          try {
            const data = JSON.parse(jsonStr);

            // Извлекаем текст из потокового ответа
            let chunk = '';
            if (data.message?.content) {
              chunk = data.message.content;
            } else if (data.response) {
              chunk = data.response;
            }

            if (chunk) {
              accumulatedText += chunk;

              // Обновляем UI с каждым токеном
              setMessages((prev) => {
                const updated = [...prev];
                const lastIndex = updated.length - 1;
                updated[lastIndex] = {
                  ...updated[lastIndex],
                  content: accumulatedText,
                  isStreaming: true,
                };
                return updated;
              });
            }

            if (data.done) {
              break;
            }
          } catch (e) {
            console.error('Parse error:', e, 'Line:', trimmedLine);
          }
        }
      }

      const endTime = Date.now();
      console.log(`⏱️ Время ответа: ${(endTime - startTime) / 1000} сек`);

      // Финальное обновление (убираем isStreaming)
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        if (updated[lastIndex]) {
          updated[lastIndex].isStreaming = false;
        }
        return updated;
      });
    } catch (error: any) {
      console.error('❌ Ошибка:', error);
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        updated[lastIndex] = {
          ...updated[lastIndex],
          content: `❌ Ошибка: ${
            error.message || 'не удалось получить ответ от AI'
          }`,
          isStreaming: false,
        };
        return updated;
      });
    } finally {
      setIsLoading(false);
    }
  };

  const testFastRequest = async () => {
    setIsLoading(true);

    try {
      const response = await fetch('http://185.182.110.94:11434/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'gemma4:e4b',
          messages: [
            {
              role: 'user',
              content: 'сколько гласных букв в латинском алфавите?',
            },
          ],
          stream: false,
          think: false,
        }),
      });

      const data = await response.json();
      const answer = data.message?.content || 'Нет ответа';

      // Добавляем ответ в чат
      setMessages((prev) => [
        ...prev,
        { role: 'assistant', content: answer, isStreaming: false },
      ]);
    } catch (error) {
      console.error('Error:', error);
      setMessages((prev) => [
        ...prev,
        {
          role: 'assistant',
          content: '❌ Ошибка при запросе',
          isStreaming: false,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const testWithAxios = async () => {
    console.log('🟢 Тест с axios начат');
    const startTime = Date.now();

    try {
      const response = await axios.post(
        'http://185.182.110.94:11434/api/chat',
        {
          model: 'gemma4:e4b',
          messages: [
            {
              role: 'user',
              content: 'сколько гласных букв в латинском алфавите?',
            },
          ],
          stream: false,
          think: false,
        },
        {
          headers: { 'Content-Type': 'application/json' },
          timeout: 30000, // 30 секунд таймаут
        }
      );

      const endTime = Date.now();
      const duration = (endTime - startTime) / 1000;

      console.log(`✅ axios: ${duration} секунд`);
      console.log(`📝 Ответ: ${response.data.message?.content}`);

      alert(
        `axios: ${duration} сек\n\nОтвет: ${response.data.message?.content?.substring(
          0,
          100
        )}...`
      );
    } catch (error) {
      console.error('❌ axios ошибка:', error);
      alert(`axios ошибка: ${error}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // sendMessage();
    }
  };

  const handleClose = (e: any) => {
    setMessages([]);
    setInput('');
    setIsLoading(false);
    onClose(e);
  };

  // Стили для темы
  const textColor = selectTheme('#000000;#ffffff', curTheme, -1);
  const bgColor = selectTheme('#ffffff;#1a1a1a', curTheme, -1);
  const userBgColor = selectTheme('#1976d2;#0d47a1', curTheme, -1);
  const assistantBgColor = selectTheme('#f0f0f0;#2d2d2d', curTheme, -1);
  const borderColor = selectTheme('#e0e0e0;#3d3d3d', curTheme, -1);

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <IconButton
          size="small"
          sx={{ position: 'fixed', right: 2, top: 2, zIndex: 9 }}
          onClick={handleClose}
          disableRipple
        >
          <CloseIcon
            sx={{
              color: selectTheme('#000000;#848d95', curTheme, 1),
            }}
          />
        </IconButton>

        <DialogContent
          id="dialogAllTextSlide"
          dividers={false}
          sx={{
            p: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden',
            backgroundColor: bgColor,
          }}
        >
          {/* Индикатор загруженного конспекта (опционально) */}
          {lectureText && lectureText.length > 0 && (
            <Box
              sx={{
                p: 1,
                backgroundColor: selectTheme('#e3f2fd;#0d3a5c', curTheme, -1),
                textAlign: 'center',
                fontSize: '0.75rem',
                color: textColor,
              }}
            >
              📚 Активен конспект: конспект загружен
            </Box>
          )}

          {/* Область сообщений */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              p: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            {messages.length === 0 && (
              <Box
                sx={{
                  textAlign: 'center',
                  mt: 4,
                  color: textColor,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  👋 Привет! Я учебный AI-помощник для студентов
                </Typography>
                <Typography variant="body2">
                  {lectureText
                    ? `Я изучил конспект лекции. Задавай вопросы по его содержанию!`
                    : `Могу помочь с конспектами, переводами и объяснением медицинских терминов`}
                </Typography>
              </Box>
            )}

            {messages.map((msg, idx) => (
              <Box
                key={idx}
                sx={{
                  display: 'flex',
                  justifyContent:
                    msg.role === 'user' ? 'flex-end' : 'flex-start',
                }}
              >
                <Paper
                  elevation={1}
                  sx={{
                    maxWidth: '100%',
                    p: 1,
                    backgroundColor:
                      msg.role === 'user' ? userBgColor : assistantBgColor,
                    color: msg.role === 'user' ? '#fff' : textColor,
                    borderRadius:
                      msg.role === 'user'
                        ? '15px 15px 5px 15px'
                        : '15px 15px 15px 5px',
                    '& p': {
                      margin: '0.25rem 0', // ← уменьшаем отступы параграфов
                    },
                    '& br': {
                      display: 'none', // ← скрываем лишние переносы
                    },
                    '& ul, & ol': {
                      margin: '0.25rem 0', // ← уменьшаем отступы списков
                      paddingLeft: '1.2rem',
                    },
                    '& li': {
                      margin: '0.1rem 0', // ← уменьшаем отступы между пунктами
                    },
                    '& h1, & h2, & h3': {
                      margin: '0.25rem 0',
                    },
                    '& blockquote': {
                      margin: '0.25rem 0',
                    },
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      fontSize: '12px',
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: formatMessage(msg.content),
                      }}
                    />
                    {msg.isStreaming && msg.content === '' && (
                      <Box
                        component="span"
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.5,
                          ml: 1,
                          fontSize: '0.8em',
                          color: textColor,
                        }}
                      >
                        <span
                          style={{
                            display: 'inline-block',
                            animation: 'spin 1s linear infinite',
                          }}
                        >
                          🔍
                        </span>
                        <span>ищу в конспекте</span>
                        <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
                      </Box>
                    )}
                  </Typography>
                </Paper>
              </Box>
            ))}

            {isLoading && messages[messages.length - 1]?.role !== 'assistant' && (
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}
              >
                <CircularProgress size={12} />
                <Typography variant="caption" color="text.secondary">
                  AI ищет ответ в конспекте...
                </Typography>
              </Box>
            )}

            <div ref={messagesEndRef} />
          </Box>

          {/* Поле ввода */}
          <Box
            sx={{
              borderTop: `1px solid ${borderColor}`,
              p: 2,
              alignItems: 'center',
              display: 'flex',
              gap: 1,
              backgroundColor: bgColor,
            }}
          >
            <TextField
              inputRef={textareaRef}
              multiline
              maxRows={4}
              placeholder="Задайте вопрос по конспекту..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
              disabled={isLoading}
              fullWidth
              variant="outlined"
              size="small"
              slotProps={{
                input: {
                  style: {
                    fontSize: '12px', // ← размер шрифта в поле ввода
                  },
                },
              }}
              sx={{
                color: textColor,
                '& .MuiOutlinedInput-root': {
                  color: textColor,
                  '& fieldset': {
                    borderColor,
                  },
                  '&:hover fieldset': {
                    borderColor: selectTheme('#1976d2;#90caf9', curTheme, -1),
                  },
                },
                '& .MuiInputBase-input': {
                  fontSize: '12px', // ← альтернативный способ
                },
                '& .MuiInputBase-inputMultiline': {
                  fontSize: '12px', // ← специально для multiline
                },
              }}
            />
            <IconButton
              onClick={sendMessage}
              disabled={isLoading || !input.trim()}
              sx={{
                backgroundColor: selectTheme('#1976d2;#1976d2', curTheme, -1),
                color: '#fff',
                borderRadius: '50%',
                width: 32,
                height: 32,
                '&:hover': {
                  backgroundColor: selectTheme('#1565c0;#64b5f6', curTheme, -1),
                },
                '&.Mui-disabled': {
                  backgroundColor: selectTheme('#b0bec5;#4a4a4a', curTheme, -1),
                },
              }}
            >
              {isLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    d="M12 5v14M5 12l7-7 7 7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>

      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
        `}
      </style>
    </div>
  );
};
